<template lang="pug">
  .award-super-vip-container
    .award-super-vip-left
      .award-super-vip(v-if="vipInfo.ariesVipTitle")
        img.logo(:src="vipInfo.ariesVipTitle" alt="")
      .award-vip-content
        HighlightText(
          className="super-vip-highlight-text"
          :text="vipInfo.guidingDesc"
          :highlightStyle="highlightStyle"
          :normalStyle="normalStyle"
        )
    .award-super-vip-right(v-if="!vipInfo.ariesVip")
      .go-open-btn(@click="toSubscribeVip")
        span {{ vipInfo.guidingButtonName }}
        img.arrow-icon(
          src="https://m.hellobike.com/resource/gallery/833/BJalaxn1QD.png"
          alt=""
        )
</template>

<script>
import { jumpUrl } from '@/utils/tools';
import HighlightText from '@/components/highlight-text';

export default {
  name: 'VipEntry',
  components: {
    HighlightText,
  },
  props: {
    vipInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    highlightStyle() {
      return {
        fontSize: '0.12rem',
        color: '#ff5729',
      };
    },
    normalStyle() {
      return {
        fontSize: '0.12rem',
        color: '#734900',
        fontWeight: 400,
      };
    },
  },
  mounted() {},
  methods: {
    toSubscribeVip() {
      const { ariesVipUrl } = this.vipInfo;
      jumpUrl(ariesVipUrl);
    },
  },
};
</script>

<style lang="less" scoped>
.award-super-vip-container {
  display: flex;
  align-items: center;
  height: 0.2rem;
  background-image: linear-gradient(90deg, #fffae8 0%, #fff2c7 100%);
  border-radius: 0.15rem;

  .award-super-vip-left {
    display: flex;
    align-items: center;

    .award-super-vip {
      .logo {
        width: auto;
        height: 0.2rem;
        vertical-align: bottom;
      }
    }

    .award-vip-content {
      display: flex;
      align-items: center;
      padding: 0 0.08rem 0 0.04rem;

      .super-vip-highlight-text {
        display: flex;
      }
    }
  }

  .go-open-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 0.04rem;
    border-radius: 0.15rem;
    font-weight: 500;
    font-size: 0.12rem;
    color: #734900;

    .arrow-icon {
      width: 0.12rem;
      height: 0.12rem;
      vertical-align: bottom;
    }
  }

  .opened-text {
    padding: 0 0.07rem 0 0.04rem;
    font-size: 0.12rem;
    color: #734900;
  }
}
</style>
